var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegendary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 15,
    viewBox: "0 0 93 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40625 0.659735L3.55556 0.659668L4.18409 1.28821L1.77778 3.69452V11.847L4.18409 14.2534L3.55556 14.8819H2.40625L0 12.5834V2.95814L2.40625 0.659735Z",
    fill: "#D06852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85071 3.41528H8.54315V10.6953H12.8987V12.1264H6.85071V3.41528Z",
    fill: "#FF7C60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.822 3.41528H21.1188V4.84639H16.5144V7.04906H20.758V8.45528H16.5144V10.6953H21.1188V12.1264H14.822V3.41528Z",
    fill: "#FF7C60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2399 10.6953V4.84639L24.6711 3.41528H29.0017L30.4079 4.82151V6.15306H28.7155V5.44373L28.1306 4.85884H25.5671L24.9324 5.49351V10.0482L25.5671 10.6828H28.1555L28.7653 10.0731V8.71662H26.8986V7.27306H30.4079V10.6953L28.9768 12.1264H24.6711L23.2399 10.6953Z",
    fill: "#FF7C60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7697 3.41528H39.0666V4.84639H34.4621V7.04906H38.7057V8.45528H34.4621V10.6953H39.0666V12.1264H32.7697V3.41528Z",
    fill: "#FF7C60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3121 3.41528H42.8303L46.713 9.3264H46.7379V3.41528H48.3681V12.1264H46.8499L42.9672 6.22773H42.9423V12.1264H41.3121V3.41528Z",
    fill: "#FF7C60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9847 3.41528H56.5598L58.0532 4.90862V10.6331L56.5598 12.1264H50.9847V3.41528ZM55.7261 10.6828L56.3607 10.0482V5.49351L55.7261 4.85884H52.6772V10.6828H55.7261Z",
    fill: "#FF7C60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8048 3.41528H64.3479L67.5337 12.1264H65.8164L65.107 10.1975H62.0457L61.3364 12.1264H59.619L62.8048 3.41528ZM64.7337 8.80373L63.5764 5.49351H63.5515L62.4315 8.80373H64.7337Z",
    fill: "#FF7C60"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2508 9.23928V12.1264H74.5584V9.62506L73.8117 8.79128H71.0988V12.1264H69.4064V3.41528H74.8695L76.2011 4.75928V7.39751L75.3549 8.25617L76.2508 9.23928ZM71.0988 7.39751H74.098L74.5335 6.96195V5.26951L74.098 4.83395H71.0988V7.39751Z",
    fill: "#FF7C60"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8462 8.56728L77.7476 3.41528H79.6018L81.68 6.98684H81.7049L83.7831 3.41528H85.6374L82.5387 8.56728V12.1264H80.8462V8.56728Z",
    fill: "#FF7C60"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0819 0.659735L88.9326 0.659668L88.3041 1.28821L90.7104 3.69452V11.847L88.3041 14.2534L88.9326 14.8819H90.0819L92.4882 12.5834V2.95814L90.0819 0.659735Z",
    fill: "#D06852"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendary);
export default __webpack_public_path__ + "static/media/legendary.a9bec11f1614c4605ffee4a47eff17e2.svg";
export { ForwardRef as ReactComponent };